import styled from 'styled-components'
import { Dropdown } from './index'

const GenderDropdown = styled(Dropdown).attrs({
  items: [
    { value: 'MALE', text: 'Male' },
    { value: 'FEMALE', text: 'Female' },
    { value: 'COEDUCATIONAL', text: 'Co-educational' },
  ],
})``

export { GenderDropdown }
